export const osVersions = {
    'Windows': [
        {
            userAgent: 'Windows NT 13.',
            osVersion: 'Windows 11'
        },
        {
            userAgent: 'Windows NT 10.',
            osVersion: 'Windows 10'
        },
        {
            userAgent: 'Windows NT 6.3',
            osVersion: 'Windows 8.1'
        },
        {
            userAgent: 'Windows NT 6.2',
            osVersion: 'Windows 8'
        },
        {
            userAgent: 'Windows NT 6.1',
            osVersion: 'Windows 7'
        },
        {
            userAgent: 'Windows NT 6.0',
            osVersion: 'Windows Vista'
        },
        {
            userAgent: 'Windows NT 5.2',
            osVersion: 'Windows Server 2003; Windows XP x64 Edition'
        },
        {
            userAgent: 'Windows NT 5.1',
            osVersion: 'Windows XP'
        },
        {
            userAgent: 'Windows NT 5.01',
            osVersion: 'Windows 2000, Service Pack 1 (SP1)'
        },
        {
            userAgent: 'Windows NT 5.0',
            osVersion: 'Windows 2000'
        },
        {
            userAgent: 'Windows NT 4.0',
            osVersion: 'Windows NT 4.0'
        },
        {
            userAgent: 'Windows 98; Win 9x 4.90',
            osVersion: 'Windows Millennium Edition (Windows Me)'
        },
        {
            userAgent: 'Windows 98',
            osVersion: 'Windows 98'
        },
        {
            userAgent: 'Windows 95',
            osVersion: 'Windows 95'
        },
        {
            userAgent: 'Windows CE',
            osVersion: 'Windows CE'
        }
    ],
    'Mac': [
        {
            userAgent: 'Mac OS X 10_0',
            osVersion: 'Cheetah'
        },
        {
            userAgent: 'Mac OS X 10_1',
            osVersion: 'Puma'
        },
        {
            userAgent: 'Mac OS X 10_2',
            osVersion: 'Jaguar'
        },
        {
            userAgent: 'Mac OS X 10_3',
            osVersion: 'Panther'
        },
        {
            userAgent: 'Mac OS X 10_4',
            osVersion: 'Tiger'
        },
        {
            userAgent: 'Mac OS X 10_5',
            osVersion: 'Leopard'
        },
        {
            userAgent: 'Mac OS X 10_6',
            osVersion: 'Snow Leopard'
        },
        {
            userAgent: 'Mac OS X 10_7',
            osVersion: 'Lion'
        },
        {
            userAgent: 'Mac OS X 10_8',
            osVersion: 'Mountain Lion'
        },
        {
            userAgent: 'Mac OS X 10_9',
            osVersion: 'Mavericks'
        },
        {
            userAgent: 'Mac OS X 10_10',
            osVersion: 'Yosemite'
        },
        {
            userAgent: 'Mac OS X 10_11',
            osVersion: 'El Capitan'
        },
        {
            userAgent: 'Mac OS X 10_12',
            osVersion: 'Sierra'
        },
        {
            userAgent: 'Mac OS X 10_13',
            osVersion: 'High Sierra'
        },
        {
            userAgent: 'Mac OS X 10_14',
            osVersion: 'Mojave'
        },
        {
            userAgent: 'Mac OS X 10_15',
            osVersion: 'Catalina'
        },
        {
            userAgent: 'Mac OS X 11',
            osVersion: 'Big Sur'
        },
        {
            userAgent: 'Mac OS X 12',
            osVersion: 'Monterey'
        },
        {
            userAgent: 'Mac OS X 13',
            osVersion: 'Ventura'
        }
    ],
    'Linux': [
        {
            userAgent: 'X11',
            osVersion: 'Linux'
        }
    ]
}